var map = {
	"./en/bluevein.md": [
		6542,
		882
	],
	"./en/my-programmer-journey.md": [
		2962,
		275
	],
	"./en/scientific-article-Analysis-of-existing-vibrating-feeders.md": [
		7625,
		912
	],
	"./ru/bluevein.md": [
		4676,
		73
	],
	"./ru/my-programmer-journey.md": [
		1804,
		478
	],
	"./ru/scientific-article-Analysis-of-existing-vibrating-feeders.md": [
		2203,
		287
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6961;
module.exports = webpackAsyncContext;